module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-Light-WebXL-f17116d2c1f2b6b4a253a866e20ce30d.woff2";